import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

const CART_ADDRESS_NUDGE_TOP = "65px";

export const ExpressContainer = styled.div({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    height: "106px",
    zIndex: 300,
});

export const OtgContainer = styled.div({
    position: "absolute",
    bottom: "0",
    right: "6px",
    width: "106px",
    height: "106px",
});

export const BoltContainer = styled.div({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    height: "106px",
    zIndex: 5,
});

export const HeaderLottieContainer = styled.div({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    height: "106px",
    zIndex: 5,
});

export const HeaderStampContainer = styled.div({
    position: "absolute",
    bottom: "0",
    right: "6px",
    width: "106px",
    height: "106px",
});

export const BoltStampContainer = styled.div({
    position: "absolute",
    bottom: "0",
    right: "6px",
    width: "106px",
    height: "106px",
});
export const AddressNudgeTooltipContainer = styled.div<{ collapse: boolean; themeChange: boolean }>(
    ({ theme, collapse, themeChange }) => ({
        "&:before": {
            content: '""',
            position: "absolute",
            top: "-6px",
            left: "44px",
            width: 0,
            height: 0,
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderBottom: `6px solid ${
                themeChange
                    ? theme.colors[theme.colorMode].warning_Sub
                    : theme.colors[theme.colorMode].background_inverse_Primary
            }`,
        },
        background: themeChange
            ? theme.colors[theme.colorMode].warning_Sub
            : theme.colors[theme.colorMode].background_inverse_Primary,
        position: "absolute",
        top: `calc(var(--sat, 0px) + ${CART_ADDRESS_NUDGE_TOP})`,
        left: theme.spacing.small,
        right: theme.spacing.small,
        padding: `${theme.spacing.xSmall} ${theme.spacing.small}`,
        display: "flex",
        alignItems: "center",
        borderRadius: theme.cornerRadius.small,
        border: "none",
        animation: collapse ? "collapseUp 0.25s ease-in forwards" : "zigZag 1s ease-in-out",
        animationDelay: collapse ? "0s" : "0.5s",
        "@keyframes zigZag": {
            "0%": { transform: `translateX(${theme.spacing.empty})` },
            "10%": { transform: `translateX(${theme.spacing.xxSmall})` },
            "20%": { transform: `translateX(calc(${theme.spacing.xxSmall} * -1))` },
            "30%": { transform: `translateX(${theme.spacing.xxSmall})` },
            "40%": { transform: `translateX(calc(${theme.spacing.xxSmall} * -1))` },
            "50%": { transform: `translateX(${theme.spacing.xxSmall})` },
            "60%": { transform: `translateX(calc(${theme.spacing.xxSmall} * -1))` },
            "70%": { transform: `translateX(${theme.spacing.xxSmall})` },
            "80%": { transform: `translateX(calc(${theme.spacing.xxSmall} * -1))` },
            "90%": { transform: `translateX(${theme.spacing.xxSmall})` },
            "100%": { transform: `translateX(${theme.spacing.empty})` },
        },

        "@keyframes collapseUp": {
            "0%": {
                transform: "translateY(0) scaleX(1)",
                transformOrigin: "51px 50%",
                opacity: 1,
                maxHeight: "40px",
                maxWidth: "200px",
            },
            "50%": {
                transform: "translateY(-10px) scaleX(0.5)",
                transformOrigin: "51px 50%",
                opacity: 0.5,
                maxHeight: "20px",
                maxWidth: "100px",
            },
            "100%": {
                transform: "translateY(-20px) scaleX(0)",
                transformOrigin: "51px 50%",
                opacity: 0,
                maxHeight: "0px",
                maxWidth: "0px",
                padding: 0,
            },
        },
    }),
);

export const AddressNudgeTooltipText = styled(Text)(({ theme }) => ({
    marginLeft: theme.spacing.xxSmall,
    overflow: "hidden",
}));

export const ClearButton = styled.div(({ theme }) => ({
    position: "absolute",
    right: theme.spacing.small,
    width: theme.spacing.medium,
    height: theme.spacing.medium,
    cursor: "pointer",
}));
